import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest, getHttpHeadersExcel } from "./ApiUtils";

const empOfferApiUrl = `${baseApiUrl}/api/EmployeeOffer`;

export async function getEmployeeOfferByEmployeeList(id) {
  return await httpRequest(fetchEmployeeOfferList.bind(this, id));
}

async function fetchEmployeeOfferList(id) {
  let config = getHttpHeaders();
  return await axios.get(`${empOfferApiUrl}/${id}`, config);
}

export async function getEmployeeOfferList(
  pageNumber,
  pageSize,
  orderBy,
  typeId,
  employeeName,
  description,
  status,
  month,
  year,
  managerId
) {
  return await httpRequest(
    fetchEmployeeOffersList.bind(
      this,
      pageNumber,
      pageSize,
      orderBy,
      typeId,
      employeeName,
      description,
      status,
      month,
      year,
      managerId
    )
  );
}

async function fetchEmployeeOffersList(
  pageNumber,
  pageSize,
  orderBy,
  typeId,
  employeeName,
  description,
  status,
  month,
  year,
  managerId
) {
  const managerIdQueries = managerId.map(managerId => `ManagerId=${managerId}`).join('&');

  const apiUrl = `${empOfferApiUrl}?Description=${description}&EmployeeName=${employeeName}&TypeId=${typeId}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${pageSize}&Status=${status}&Month=${month}&Year=${year}&${managerIdQueries}`;

  let config = getHttpHeaders();

  return await axios.get(apiUrl, config);
}

export async function updateEmployeeOffer(employeeOffer) {
  return await httpRequest(putEmployeeOffer.bind(this, employeeOffer));
}

async function putEmployeeOffer(employeeOffer) {
  let config = getHttpHeaders();
  return await axios.put(`${empOfferApiUrl}`, employeeOffer, config);
}

export async function addEmployeeOffer(newEmployeeOffer) {
  return await httpRequest(postEmployeeOffer.bind(this, newEmployeeOffer));
}

async function postEmployeeOffer(newEmployeeOffer) {
  let config = getHttpHeaders();
  return await axios.post(`${empOfferApiUrl}`, newEmployeeOffer, config);
}

export async function deleteEmployeeOffer(id) {
  return await httpRequest(fetchDeleteEmployeeOffer.bind(this, id));
}

async function fetchDeleteEmployeeOffer(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${empOfferApiUrl}/${id}`, config);
}

export async function getEmployeeOffersCounters(id) {
  return await httpRequest(fetchEmployeeOffersCounters.bind(this, id));
}

async function fetchEmployeeOffersCounters(id) {
  let config = getHttpHeaders();
  return await axios.get(`${empOfferApiUrl}/Counters?EmployeeId=${id}`, config);
}

export async function generateOffers() {
  return await httpRequest(getGenerateOffers.bind(this));
}

async function getGenerateOffers() {
  let config = getHttpHeaders();
  return await axios.get(`${empOfferApiUrl}/GenerateOffers`, config);
}

export async function getEmployeeOffersExcel(
  pageNumber,
  pageSize,
  orderBy,
  typeId,
  employeeName,
  description,
  status,
  month,
  year,
  managerId
) {
  return await httpRequest(fetchgetEmployeeOffersExcel.bind(this,
    pageNumber,
    pageSize,
    orderBy,
    typeId,
    employeeName,
    description,
    status,
    month,
    year,
    managerId
  ));
}
async function fetchgetEmployeeOffersExcel(
  pageNumber,
  pageSize,
  orderBy,
  typeId,
  employeeName,
  description,
  status,
  month,
  year,
  managerId
) {
  const managerIdQueries = managerId.map(managerId => `ManagerId=${managerId}`).join('&');

  let config = getHttpHeadersExcel();

  return await axios.get(`${empOfferApiUrl}/OffersExcel?Description=${description}&EmployeeName=${employeeName}&TypeId=${typeId}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${pageSize}&Status=${status}&Month=${month}&Year=${year}&${managerIdQueries}`, config);
}
